"use client";

import React, { PropsWithChildren, useEffect, useState } from "react";
import { CookieName } from "@/types/nextCookie";
import { AdminModal } from ".";

type Props = PropsWithChildren;

function getCookieValue(name: string): string | undefined {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

const AdminModalTrigger: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [domain, setDomain] = useState("");

  useEffect(() => {
    setDomain(window?.location.host);
  }, []);

  useEffect(() => {
    if (domain !== "staging.gondola.ai" && domain !== "localhost:3000") return;

    fetch("/api/admin/check")
      .then((res) => res.json())
      .then((data) => setIsAdmin(data.isAdmin))
      .catch(() => setIsAdmin(false));
  }, [domain]);

  if (
    (domain === "staging.gondola.ai" || domain === "localhost:3000") &&
    isAdmin
  ) {
    return (
      <>
        <AdminModal
          open={open}
          onOpenChange={() => setOpen(false)}
          cookieUserId={getCookieValue(CookieName.USER_ID)}
        />
        <div onClick={() => setOpen(true)}>{children}</div>
      </>
    );
  } else {
    return null;
  }
};

export default AdminModalTrigger;
